(() => {
  const button = document.querySelector('[data-soffa-cookie-preferences]');
  if (!button) return;
  button.addEventListener('click', async () => {
    const status = document.querySelector('[data-soffa-cookie-status]');
    status.hidden = true;
    button.disabled = true;
    try {
      if (!window.privacyBanner?.showPreferences) throw new Error('Privacy controls unavailable');
      await window.privacyBanner.showPreferences();
    } catch (_) { status.hidden = false; }
    finally { button.disabled = false; }
  });
})();
